import { CreateStaffAvaialbilityConfigRequest, StattAppointmentTypeLinkResponse } from '../models/staff-availability-config';
import { Observable, catchError, map, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@fitness-force/environments';
import { CheckRecurringAvailability, StaffAvailableResponse } from '../models/staff-availability';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import { StafAvailabilityConfigResponse } from '../models/staff-availability-config';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class StaffAvailabilityService {
  private http = inject(HttpClient);
  private router = inject(Router);


  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  GetStaffAvailability(tenantId: number, staffId: number):Observable<StafAvailabilityConfigResponse>
  {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.STAFF_AVAILABILITY.GET_STAFF_AVAILABILITY_CONFIG
      .replace('{tenant_id}', tenantId.toString())
      .replace('{staff_id}', staffId.toString());
    return this.http.get(url, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  CreateStaffAvailability(tenantId: number, staffId: number, payload:CreateStaffAvaialbilityConfigRequest):Observable<any>
  {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.STAFF_AVAILABILITY.CREATE_STAFF_AVAILABILITY_CONFIG
      .replace('{tenant_id}', tenantId.toString())
      .replace('{staff_id}', staffId.toString());
    return this.http.post(url, payload,this.httpOptions).pipe(
      map((res: any) => {
        return res;
      }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  EditStaffAvailability(tenantId: number, staffId: number,scheduleGroupId:number, payload:CreateStaffAvaialbilityConfigRequest):Observable<any>
  {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.STAFF_AVAILABILITY.UPDATE_STAFF_AVAILABILITY_CONFIG
      .replace('{tenant_id}', tenantId.toString())
      .replace('{staff_id}', staffId.toString())
      .replace('{schedule_group_id}', scheduleGroupId.toString());
    return this.http.put(url, payload,this.httpOptions).pipe(
      map((res: any) => {
        return res;
      }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  GetStaffAppointmentTypeLink(tenantId: number, staffId: number):Observable<StattAppointmentTypeLinkResponse>
  {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.STAFF_AVAILABILITY.GET_STAFF_APPOINTMENT_TYPE_LINKS
      .replace('{tenant_id}', tenantId.toString())
      .replace('{staff_id}', staffId.toString());
    return this.http.get(url, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  checkStaffAvailabilityForClass(tenantId:number, staffId:number, params:any):Observable<StaffAvailableResponse>
  {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.STAFF_AVAILABILITY.CHECK_STAFF_AVAILABILITY_FOR_CLASS
      .replace('{tenant_id}', tenantId.toString())
      .replace('{staff_id}', staffId.toString());

    let parsedParams = new HttpParams()
     params.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });

    return this.http.get(url,{
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(
      map((res: any) => {
        return res;
      }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  checkStaffAvailabilityForAppointment(tenantId:number, staffId:number, appointmentId:number, params:any):Observable<StaffAvailableResponse>
  {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.STAFF_AVAILABILITY.CHECK_STAFF_AVAILABILITY_FOR_APPOINTMENT
      .replace('{tenant_id}', tenantId.toString())
      .replace('{appointment_id}', appointmentId.toString())
      .replace('{staff_id}', staffId.toString());
    
    let parsedParams = new HttpParams()
     params.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });

    return this.http.get(url, {
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(
      map((res: any) => {
        return res;
      }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  checkStaffAvailabilityForRecurringClass(tenantId:number, staffId:number, payload:CheckRecurringAvailability):Observable<StaffAvailableResponse>
  {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.STAFF_AVAILABILITY.CHECK_STAFF_AVAILABILITY_FOR_RECURRING_CLASS
      .replace('{tenant_id}', tenantId.toString())
      .replace('{staff_id}', staffId.toString());
    return this.http.post(url, payload, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  checkStaffAvailabilityForrecurringAppointment(tenantId:number, staffId:number, appointmentId:number, payload:CheckRecurringAvailability):Observable<StaffAvailableResponse>
  {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.STAFF_AVAILABILITY.CHECK_STAFF_AVAILABILITY_FOR_RECURRING_APPOINTMENT
      .replace('{tenant_id}', tenantId.toString())
      .replace('{appointment_id}', appointmentId.toString())
      .replace('{staff_id}', staffId.toString());
    return this.http.post(url, payload, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

}
